// extracted by mini-css-extract-plugin
module.exports = {"card":"MapMobile_card__a7dRo","content":"MapMobile_content__lMasq","block-type-and-place":"MapMobile_block-type-and-place__Cn3q7"};